import { css } from '@emotion/react';

export function cssPropVar(key: string, fallback?: string) {
	return fallback ? `var(${key},${fallback})` : `var(${key})`;
}

export const pxToEm = (px: number) => px / 16 + 'em';
export const pxToPercent = (px: number) => (100 / 16) * px + '%';

export const row = css`
	margin: calc(var(--dimension-gap) / -2);
`;

export const col = css`
	margin: calc(var(--dimension-gap) / 2);
`;

export const resetButton = css`
	cursor: pointer;
	appearance: none;
	font: inherit;
	background: transparent;
	color: inherit;
	border: 0;
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	border-radius: 0;

	&::-moz-focus-inner {
		border: 0;
	}

	&:active,
	&:focus,
	&:focus-visible {
		outline: none;
	}

	&:disabled {
		cursor: default;
	}
`;

export const focusRing = css`
	&:active,
	&:current,
	&:focus {
		outline: none;
	}
	&:focus-visible {
		outline: 4px solid var(--color-primary);
		outline-offset: 2px;
	}
`;

export const button = ({ isPrimary = true }) => [
	resetButton,
	css`
		text-decoration: none;
		color: var(--color-${isPrimary ? 'primaryContrast' : 'fg'});
		background-color: var(--color-${isPrimary ? 'primary' : 'bg'});
		cursor: pointer;
		padding: 0.4em 0.8em;
		position: relative;
		border: 2px solid var(--color-${isPrimary ? 'primary' : 'grey2'});
		border-radius: 2em;

		&:disabled {
			background-color: var(--color-grey1);
			border-color: var(--color-grey1);
			color: var(--color-grey1Contrast);
			cursor: inherit;
		}

		&:visited {
			color: currentColor;
		}

		&:not(:disabled) {
			&:active,
			&:focus,
			&:hover {
				border-color: var(--color-${isPrimary ? 'fg' : 'bg'});
			}
		}
	`,
	focusRing,
];

export const container = ({ limit = true, narrow = false, padding = true, margin = false }) => [
	css`
		container-type: inline-size;
		container-name: container;
	`,
	limit
		? css`
				max-width: var(${narrow ? '--dimension-maxWidthNarrow' : '--dimension-maxWidth'});
				margin-left: auto;
				margin-right: auto;
			`
		: null,
	padding
		? css`
				box-sizing: border-box;
				padding-left: var(--dimension-container-padding-x);
				padding-right: var(--dimension-container-padding-x);
			`
		: null,
	margin
		? css`
				margin-top: var(--dimension-container-margin-y);
				margin-bottom: var(--dimension-container-margin-y);
			`
		: null,
];

export const typography = ({ size = 'm', weight = 'normal', font = 'serif', style = 'normal', decoration = 'initial', transform = 'none' }) => {
	return css`
		font-family: var(--font-${font}-family);
		font-size: var(--font-${font}-size-${size});
		font-weight: var(--font-${font}-weight-${weight});
		line-height: var(--font-${font}-lineHeight-${size});
		font-style: ${style};
		text-decoration: ${decoration};
		text-transform: ${transform};
	`;
};
